export enum ColumnFilterType {
  Equals = 1,
  DoesNotEqual = 2,
  LessThan = 3,
  LessThanOrEqualTo = 4,
  GreaterThan = 5,
  GreaterThanOrEqualTo  = 6,
  Like  = 7,
  StartsWith = 8,
  EndsWith = 9,
  Contains = 10,
  DoesNotStartWith = 11,
  DoesNotContain = 12,
  DoesNotEndWith = 13,
  NotLike = 14
}